export class DebugOverlay {
  private el: HTMLDivElement;

  constructor() {
    this.el = document.createElement('div');
    Object.assign(this.el.style, {
      position: 'fixed',
      top: '8px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(0,0,0,0.65)',
      color: '#00ff99',
      fontFamily: 'monospace',
      fontSize: '13px',
      lineHeight: '1.6',
      padding: '6px 12px',
      borderRadius: '6px',
      pointerEvents: 'none',
      zIndex: '9999',
      whiteSpace: 'pre',
      border: '1px solid rgba(0,255,153,0.25)',
    });
    document.body.appendChild(this.el);
  }

  update(fps: number, sentPerSec: number, recvPerSec: number): void {
    this.el.textContent =
      `FPS  ${fps.toFixed(1)}\n` +
      `TX   ${fmt(sentPerSec)}\n` +
      `RX   ${fmt(recvPerSec)}`;
  }

  destroy(): void {
    this.el.remove();
  }
}

function fmt(bytesPerSec: number): string {
  if (bytesPerSec >= 1024) return `${(bytesPerSec / 1024).toFixed(1)} KB/s`;
  return `${Math.round(bytesPerSec)} B/s`;
}
